module.exports = __webpack_public_path__ + "img/verolabs-logo.f81adbee.png";